import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';
import { RETURN_TO_KEY, SPONSORED_INVITE_PENDING_KEY } from '../components/ProtectedRoute';
import { FullPageLoading } from '../components/FullPageLoading';

export function Callback() {
  const auth = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (auth.isLoading) return;
    if (!auth.isAuthenticated) {
      navigate('/login', { replace: true });
      return;
    }
    let returnTo = '/';
    try {
      const saved = sessionStorage.getItem(RETURN_TO_KEY);
      sessionStorage.removeItem(RETURN_TO_KEY);
      // Same-app absolute paths only — never a full URL or protocol-relative value.
      if (saved && saved.startsWith('/') && !saved.startsWith('//')) returnTo = saved;
    } catch {
      // ignore storage failures (e.g. private browsing)
    }
    try {
      // Belt-and-braces clear of the sponsored-invite flag (steward-app#1649), alongside the
      // unconditional one `Login.tsx`'s `returnedForInvite` already applies on read. No known
      // path reaches /callback with the flag still set and /login never rendered — `ProtectedRoute`
      // only sets the flag on the same bounce that sends the user to /login — but the clear costs
      // nothing and matches how `RETURN_TO_KEY` is handled two lines above.
      sessionStorage.removeItem(SPONSORED_INVITE_PENDING_KEY);
    } catch {
      // ignore storage failures (e.g. private browsing)
    }
    navigate(returnTo, { replace: true });
  }, [auth.isLoading, auth.isAuthenticated, navigate]);

  return <FullPageLoading label="Completing sign in…" />;
}
